<template>
  <LayoutPC v-if="isMobile === 'PC'" />
  <LayoutH5 v-if="isMobile === 'MOBILE'" />
</template>

<script setup>
import LayoutPC from './components/LayoutPC/index.vue'
import LayoutH5 from './components/LayoutH5/index.vue'
import { useStore } from 'vuex'
import { fetchData } from '@/utils/fetch'
import { useCouponDialog } from '@/components/Login/hooks/useCouponDialog.js'
import { useIntercomObserver } from '@/components/AdaptiveIntercomFooter/useIntercomObserver'
import { useGoogleOneTap } from '@/hooks/useGoogleOneTap'
import { useSearchUrl } from '@/hooks/useSearchUrl'
import { useLanguage } from './hooks/useLanguage'

const store = useStore()
const { init: initSearchUrl } = useSearchUrl()

const { initLanguage } = useLanguage()

useCouponDialog()
useIntercomObserver()
useGoogleOneTap()

const isMobile = ref(false)
onBeforeMount(() => {
  initLanguage()

  getCartCount()
  initSearchUrl()
  const userAgent = navigator.userAgent.toLowerCase()
  isMobile.value = /iphone|ipod|ipad|android|blackberry|windows phone/i.test(userAgent) ? 'MOBILE' : 'PC'
})

const getCartCount = () => {
  fetchData('/appb/b2b/cart/cartCount').then(res => {
    if (res.code === 200) {
      store.commit('cart/SET_CART_COUNT', res.data)
    }
  })
}
</script>
